export default __webpack_public_path__ + "static/media/copy-clipboard.7eeff630.svg";